import { useToastController } from '@tamagui/toast';
import { CheckCircle2 } from 'lucide-react';
import { tokens } from 'tamagui-config';

export function useShowSuccessToast() {
  const toast = useToastController();

  return (title: string, message?: string) => {
    toast.show(title, {
      message,
      icon: <CheckCircle2 color={tokens.color.black2} size={48} />,
      backgroundColor: '$successGreen',
      duration: 2000,
    });
  };
}
